/* eslint-disable react/no-children-prop */
import React from "react";
import { useSelector } from "react-redux";
import { selectPaperworkData, selectPaperworkStageProgress } from "store/PaperWork/selectors";
import Wrapper from "./styled";
import { Title, Content, Column, Text } from "../styled";
import { get } from "lodash";

const RealStateTax = ({ selectedPlot }) => {
  const data = useSelector(selectPaperworkData);
  const realStateTax = get(data, `[${selectedPlot}].domainData.realStateTax[0]`, {});
  const stageProgress = useSelector(selectPaperworkStageProgress);
  const otherInputsData = get(stageProgress, "[0].otherInputsData", {});
  const isUnconstitutedLand = get(Object.values(otherInputsData)[0], "unconstitutedLand", false);
  const owner = get(data, "[0].domainData.owners[0]", {});

  const name = isUnconstitutedLand ? get(owner, "businessName", "-") : get(realStateTax, "name", "-");
  const CUIT = isUnconstitutedLand ? `CUIT ${get(owner, "cuit", "-")}` : get(realStateTax, "CUIT", "-");
  const address = isUnconstitutedLand ? get(owner, "address", "-") : get(realStateTax, "address", "-");
  const department = get(realStateTax, "department", "-");
  const floor = get(realStateTax, "floor", "-");
  const location = get(realStateTax, "location", "-");

  return (
    <Wrapper>
      <Title children="Contribuyente impuesto inmobiliario" />
      <Content>
        <Column>
          <Text children={`Nombre y apellido: ${name}`} />
          <Text children={`Identificación: ${CUIT}`} />
          <Text children={`Dirección: ${address}`} />
          <Text children={`Departamento: ${department}`} />
          <Text children={`Piso: ${floor}`} />
          <Text children={`Localidad: ${location}`} />
        </Column>
      </Content>
    </Wrapper>
  );
};

export default RealStateTax;
